const taPageStrings = {
  navbar: {
    appName: "TA Connect",
    login: "Login",
    register: "Register",
  },

  taPage: {
    title: "TA Actions",
    description:
      "Use the sidebar to navigate to actions for creating and managing slots. The Delete / Update / Toggle actions are placeholders and will be added later.",
    createSlot: "Create Slot",
    booking: "Booking",
    bookings: "Bookings",
    bookedSessions: "Booked Sessions",
    weekSchedule: {
      title: "Weekly Schedule",
      loading: "Loading schedule...",
      errorLoading: "Failed to load schedule. Please try again.",
      noSlots: "No time slots found.",
      noSlotsToday: "No slots",
      createFirstSlot: "Create Your First Slot",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },
  },
};

export default taPageStrings;
